export default __webpack_public_path__ + "static/media/notify.021c2ca7.webp";